<template>
  <b-modal
    ref="add-contact"
    :visible="showModal"
    :title="$t('modals.new_contact')"
    centered
    size="md"
    :ok-title="$t('actions.submit')"
    :cancel-title="$t('actions.cancel')"
    @ok="addNewContact"
    @hidden="closeModal"
  >
    <div>
      <b-form-group :label="$t('field.name')">
        <b-form-input
          v-model="contactName"
          name="name"
          type="text"
          required
          placeholder="Lorem ipsum set dolor"
        />
      </b-form-group>
      <b-form-group :label="$t('field.email')">
        <b-form-input
          v-model="contactEmail"
          name="email"
          type="email"
          required
          placeholder="lorem@ipsum.dolor"
        />
      </b-form-group>
      <b-form-group :label="$t('field.phone')">
        <b-form-input
          v-model="contactPhone"
          name="phone"
          type="text"
          required
          placeholder="123456789"
        />
      </b-form-group>
    </div>
  </b-modal>
</template>
<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({
    contactName: null,
    contactEmail: null,
    contactPhone: null
  }),
  methods: {
    closeModal() {
      this.$emit('close')
    },
    addNewContact() {
      this.$emit(
        'addNewContact',
        this.contactName,
        this.contactEmail,
        this.contactPhone
      )
    }
  }
}
</script>
